<template>
  <div>
      <div class="container-fluid my-4">
        <div class="row">
          <div class="col-6">
            <h6 class="m-0 text-mcf-color">{{ title }}</h6>
          </div>
        </div>
      </div>
      <NotificationList class="m-3" />
  </div>
</template>

<script>
import NotificationList from '@/components/notification/NotificationList.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    NotificationList,
  },
  data() {
    return {
      // 標題
      title: '',
    };
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'Notification')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
      });
  },
};
</script>
